import { render, staticRenderFns } from "./SlideGameRecapDesktop.vue?vue&type=template&id=0d4786d8&scoped=true&"
import script from "./SlideGameRecapDesktop.vue?vue&type=script&lang=js&"
export * from "./SlideGameRecapDesktop.vue?vue&type=script&lang=js&"
import style0 from "./SlideGameRecapDesktop.vue?vue&type=style&index=0&id=0d4786d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d4786d8",
  null
  
)

export default component.exports